import React from 'react';
import { Toaster } from 'react-hot-toast';
import TerminosAllList from './TerminosAllList';
import { Outlet } from 'react-router-dom';

import '../../../assets/css/App.css';

export default function TerminosAll({ data, setChildrenAction }) {

    if (data.terminosAll.valorEsperado != null) {
        return (
            <>        
                <TerminosAllList rows={ data.terminosAll.valorEsperado } setChildrenAction={setChildrenAction} />

                <Outlet />
                
            </>      
        );
    }
    else
    {
        return (
            <h2>
                Aún no hay acuerdos configurados.
            </h2>
        );
    }
};